import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { usePerspective } from "@/context/PerspectiveContext";
import { getContent } from "@/content/perspectives";

const Services = () => {
  const { perspective } = usePerspective();
  const { services } = getContent(perspective);
  return (
  <section id="services" data-testid="services-section" className="bg-ink px-6 py-28 lg:px-12 lg:py-40">
    <div className="mx-auto max-w-[1500px]">
      <div className="mb-20 grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
              {services.overline}
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-5xl font-medium leading-[1] tracking-tight text-white lg:text-7xl">
              {services.titleTop}<br />
              <span className="italic text-white/50">{services.titleItalic}</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <p className="text-base font-light leading-relaxed text-white/50">
              {services.intro}
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2">
        {services.cards.map((s, i) => (
          <Reveal key={s.no} delay={(i % 2) * 0.08}>
            <motion.div
              whileHover={{ backgroundColor: "#0247a6" }}
              transition={{ duration: 0.4 }}
              className="group h-full bg-ink p-10 lg:p-14"
              data-testid={`service-card-${s.no}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-sm text-cobalt transition-colors group-hover:text-white/80">
                  {s.no}
                </span>
                <ArrowUpRight
                  size={22}
                  className="text-white/20 transition-all duration-300 group-hover:text-white group-hover:rotate-0"
                />
              </div>
              <h3 className="mt-8 font-serif text-3xl font-medium leading-tight text-white lg:text-4xl">
                {s.title}
              </h3>
              <p className="mt-5 max-w-md text-base font-light leading-relaxed text-white/55 group-hover:text-white/80">
                {s.desc}
              </p>
              <div className="mt-8 flex flex-wrap gap-2">
                {s.tags.map((t) => (
                  <span
                    key={t}
                    className="border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.12em] text-white/60 group-hover:border-white/30"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Services;
